import { SerializedStyles } from '@emotion/react';
import { css, Theme } from '@mui/material/styles';

export const GenericDataGridStyle = (theme: Theme): SerializedStyles =>
  css({
    border: 'none',
    gap: '0.75rem',
    // GRID
    '.MuiDataGrid-main': {
      outline: `1px solid ${theme.palette.divider}`,
      borderRadius: 8,
      backgroundColor: theme.palette.background.paper,
    },
    // HEADER
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: theme.palette.mode === 'dark' ? 'rgb(71, 72, 77)' : '#f8f9fc',
      borderRadius: '8px 8px 0 0',
    },
    '.MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },
    '.MuiDataGrid-columnHeaderTitleContainer': {
      justifyContent: 'space-between',
    },
    '.MuiDataGrid-columnHeaderTitle': {
      textTransform: 'capitalize',
    },
    '.MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    // ROW
    '.MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: theme.palette.mode === 'dark' ? '#191a1f' : '#f8f9fc',
    },
    '.MuiDataGrid-row:last-of-type .MuiDataGrid-cell': {
      borderBottom: 'none',
    },
    '.MuiDataGrid-row:hover': {
      background: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F6F7F8',
    },
    '.MuiDataGrid-row.Mui-selected, .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.selected : '#edeff2',
    },
    '.MuiDataGrid-row.single-selected, .MuiDataGrid-row.single-selected:hover': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.selected : '#edeff2',
      boxShadow: theme.palette.mode === 'dark' ? '0px 0px 8px rgba(0, 0, 0, 0.3)' : '0px 0px 8px rgba(0, 0, 0, 0.2)',
      zIndex: 1,
    },
    // CELL
    '.MuiDataGrid-main .MuiInputBase-root': {
      height: '100%',
      borderRadius: '0 !important',
    },
    '.MuiDataGrid-cell.locked': {
      color: theme.palette.text.disabled,
    },
    '& .MuiDataGrid-cell.error': {
      color: theme.palette.mode === 'dark' ? 'rgb(244, 199, 199)' : '#C7322F',
      background: theme.palette.mode === 'dark' ? 'rgb(22, 11, 11)' : '#FDEBED',
    },
    '.MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within': {
      outline: `solid ${theme.palette.action.disabled} 1px`,
    },
    '.MuiDataGrid-cell--editable:focus, .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within, .MuiDataGrid-cell--editing':
      {
        outline: `solid ${theme.palette.primary.main} 1px`,
        outlineOffset: '-1px',
      },
    '.MuiDataGrid-cell--editing:has(.Mui-error)': {
      outline: `solid ${theme.palette.error.main} 1px !important`,
    },
    // SCROLLBAR
    '.MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
      background: 'transparent !important',
    },
  });
